import OnTokenizeAndResumeHandlers from "../../../../content/sdk/web/2.x.x/_common/onTokenizeAndResumeHandlers";
import PaymentMethodTokenDataWeb from "../../../../content/sdk/web/2.x.x/_common/PrimerPaymentMethodTokenDataPropsWeb";
import * as React from 'react';
export default {
  OnTokenizeAndResumeHandlers,
  PaymentMethodTokenDataWeb,
  React
};